module.exports = __webpack_public_path__ + "img/alert-triangle-icon.84306156.svg";